module.exports = __webpack_public_path__ + "static/media/kirmas.5e33b0fd.png";